import { render, staticRenderFns } from "./wxwl-wxdl.vue?vue&type=template&id=5b98f5d0"
import script from "./wxwl-wxdl.vue?vue&type=script&lang=js"
export * from "./wxwl-wxdl.vue?vue&type=script&lang=js"
import style0 from "./wxwl-wxdl.vue?vue&type=style&index=0&id=5b98f5d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports